var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGreenCheckFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 8.33301C12.6665 11.0944 10.4279 13.333 7.6665 13.333C4.90508 13.333 2.6665 11.0944 2.6665 8.33301C2.6665 5.57158 4.90508 3.33301 7.6665 3.33301C10.4279 3.33301 12.6665 5.57158 12.6665 8.33301Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99998 14.3996C11.5346 14.3996 14.4 11.5342 14.4 7.99961C14.4 4.46499 11.5346 1.59961 7.99998 1.59961C4.46535 1.59961 1.59998 4.46499 1.59998 7.99961C1.59998 11.5342 4.46535 14.3996 7.99998 14.3996ZM10.9657 6.96529C11.2781 6.65288 11.2781 6.14634 10.9657 5.83392C10.6532 5.5215 10.1467 5.5215 9.83429 5.83392L7.19998 8.46824L6.16566 7.43392C5.85324 7.1215 5.34671 7.1215 5.03429 7.43392C4.72187 7.74634 4.72187 8.25287 5.03429 8.56529L6.63429 10.1653C6.94671 10.4777 7.45324 10.4777 7.76566 10.1653L10.9657 6.96529Z",
    fill: "#399D81"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19998 8.46824L9.83429 5.83392C10.1467 5.5215 10.6532 5.5215 10.9657 5.83392C11.2781 6.14634 11.2781 6.65288 10.9657 6.96529L7.76566 10.1653C7.45324 10.4777 6.94671 10.4777 6.63429 10.1653L5.03429 8.56529C4.72187 8.25287 4.72187 7.74634 5.03429 7.43392C5.34671 7.1215 5.85324 7.1215 6.16566 7.43392L7.19998 8.46824ZM15.4 7.99961C15.4 12.0865 12.0869 15.3996 7.99998 15.3996C3.91307 15.3996 0.599976 12.0865 0.599976 7.99961C0.599976 3.9127 3.91307 0.599609 7.99998 0.599609C12.0869 0.599609 15.4 3.9127 15.4 7.99961ZM14.4 7.99961C14.4 11.5342 11.5346 14.3996 7.99998 14.3996C4.46535 14.3996 1.59998 11.5342 1.59998 7.99961C1.59998 4.46499 4.46535 1.59961 7.99998 1.59961C11.5346 1.59961 14.4 4.46499 14.4 7.99961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreenCheckFilled);
export default __webpack_public_path__ + "static/media/icon-green-check-filled.f79f4da4401c0939da5039dad7c6616a.svg";
export { ForwardRef as ReactComponent };